<template>
    <!-- Hero Start -->
    <section class="bg-auth-home d-table w-100">
        <div class="container">
            <div class="row align-items-center">
                <div class="col-lg-7 col-md-6">
                    <div class="me-lg-5">
                        <img src="/assets/images/user/signup.svg" class="img-fluid d-block mx-auto" alt="">
                    </div>
                </div>
                <div class="col-lg-5 col-md-6">
                    <div class="card shadow rounded border-0">
                        <div class="card-body">
                            <h4 class="card-title text-center">Password Reset</h4>
                            <form class="login-form mt-4" @submit.prevent="reset()">
                                <div v-if="error !== null" class="alert alert-danger alert-dismissible fade show" role="alert">
                                    <button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close" @click="error = null"></button>
                                    <strong>{{error}}</strong>
                                </div>

                                <div class="row">
                                    <div class="col-md-12">
                                        <div class="mb-3">
                                            <label class="form-label" to="login-email">Email</label>
                                            <input type="tel" class="form-control ps-5" id="login-email" placeholder=""
                                                   aria-label="phone" v-model="user.email" dir="ltr"
                                                   :class="{ 'is-invalid' : isInvalid('email') }">
                                            <div class="invalid-feedback text-danger" v-if="isInvalid('email')">
                                                {{ isInvalid('email') }}
                                            </div>
                                        </div>
                                    </div>

<!--                                    <div class="col-md-12">-->
<!--                                        <div class="mb-3">-->
<!--                                            <label class="form-label" to="login-code">Verification Code</label>-->
<!--                                            <input type="text" class="form-control ps-5" id="login-code"-->
<!--                                                   placeholder="Enter the verification code sent by SMS."-->
<!--                                                   aria-label="verification code" v-model="user.code" dir="ltr"-->
<!--                                                   :class="{ 'is-invalid' : isInvalid('code') }">-->
<!--                                            <div class="invalid-feedback text-danger" v-if="isInvalid('code')">-->
<!--                                                {{ isInvalid('code') }}-->
<!--                                            </div>-->
<!--                                        </div>-->
<!--                                    </div>-->

                                    <div class="col-md-12">
                                        <div class="mb-3">
                                            <label class="form-label">New Password</label>
                                            <input type="password" class="form-control ps-5" id="login-password"
                                                   aria-label="new password" v-model="user.password"
                                                   :class="{ 'is-invalid' : isInvalid('password') }">
                                            <div class="invalid-feedback text-danger" v-if="isInvalid('password')">
                                                {{ isInvalid('password') }}
                                            </div>
<!--                                            <small class="text-brand-primary">يجب ان تتكون من ٨ احرف وارقام</small>-->
                                        </div>
                                    </div>

                                    <div class="col-md-12">
                                        <div class="mb-3">
                                            <label class="form-label">Confirm Password</label>
                                            <input type="password" class="form-control ps-5" id="login-password_confirmation"
                                                   aria-label="confirm password" v-model="user.password_confirmation"
                                                   :class="{ 'is-invalid' : isInvalid('password_confirmation') }">
                                            <div class="invalid-feedback text-danger" v-if="isInvalid('password_confirmation')">
                                                {{ isInvalid('password_confirmation') }}
                                            </div>
                                        </div>
                                    </div>

                                    <div class="col-md-12">
                                        <div class="d-grid">
                                            <button class="btn btn-primary" type="submit">Reset Password</button>
                                        </div>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div> <!--end col-->
            </div><!--end row-->
        </div> <!--end container-->
    </section><!--end section-->
    <!-- Hero End -->
</template>

<script>
import { useToast } from "vue-toastification";
const toast = useToast();
export default {
    inject: ['auth'],
    data() {
        return {
            user: {
                email : this.$route.query?.email,
                token : this.$route?.params?.token
            },
            error: null,
            validationErrors: null,
        }
    },
    methods: {
        isInvalid(name) {
            return this.validationErrors != null ? this.validationErrors[name]?.join() : false;
        },
        reset() {
            const that = this;
            this.error = null;
            this.validationErrors = null;
            const id = toast.info('The new password is being saved.', {
                'icon': ' fa-solid fa-comment-sms >'
            });

            axios.post('password/reset', this.user)
                .then(response => {
                    toast.dismiss(id);

                    toast.success(response.data.message, {
                        timeout: 3000
                    }, { icon: 'fa-solid fa-circle-check' });

                    that.$router.push({ name: 'login' , query: { 'email': that.user.email }});

                })
                .catch(function (error) {
                    toast.dismiss(id);
                    if (error.response) {
                        that.validationErrors = error.response.data.errors;
                    }
                });
        }
    },
}
</script>
